import { IPolicy, IPolicyList } from '../../../../../redux/slices/PolicyListSlice/types';

export interface Inclusion {
    label: string;
    value: string | null;
}

export interface Exclusion {
    label: string;
    value: string | null;
}

export interface IPolicyInclusions {
    inclusion: Inclusion[];
    exclusion: Exclusion[];
    documentType?: string;
    claimsIntimation?: string;
}

export interface INextPolicy {
    completedPolicy?: IPolicy;
    isPendingPolicyEmpty: boolean;
    navigateNext: () => void;
    rawPolicyList: IPolicyList;
    pendingPolicies: string[];
}

export enum IPolicyEnrolmentStatusUI {
    PENDING_AND_OPEN = 0,
    ENROLED_AND_OPEN = 1,
    ENROLED_AND_CLOSED = 2,
    PENDING_AND_CLOSED = 3,
}
